<app-leveltwo [pageId]="3">
    <div heading="General Info" class="General">
      <h3></h3>

        <button type="button" class="btn btn-primary">RP-10 Form</button>

    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
